import getFirstWeekOfYear from '../selectors/getFirstWeekOfYear';
import getOwaUserConfigurationOperation from 'owa-service/lib/operation/getOwaUserConfigurationOperation';
import getShowWeekNumbers from '../selectors/getShowWeekNumbers';
import getTimeIncrement from '../selectors/getTimeIncrement';
import getWeekStartDay from '../selectors/getWeekStartDay';
import getWorkDays from '../selectors/getWorkDays';
import getWorkingHoursEndTime from '../selectors/getWorkingHoursEndTime';
import getWorkingHoursStartTime from '../selectors/getWorkingHoursStartTime';
import getWorkingHoursTimeZoneId from '../selectors/getWorkingHoursTimeZoneId';
import logDataOnSaveAppearance from '../utils/logDataOnSaveAppearance';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import updateSurfaceOptions from '../data/actions/updateSurfaceOptions';
import { action } from 'satcheljs/lib/legacy';
import { updateUserOptions } from 'owa-options-core';
import {
    saveCalendarMailboxConfiguration,
    updateCalendarMailboxConfiguration,
} from 'owa-calendar-configuration';
import setWorkingHoursTimeZoneId from '../data/mutators/setWorkingHoursTimeZoneId';

/**
 *  Called when clicked on Save button in calendar settings panel.
 *  Updates user options so that the changes are reflected in current user session
 *  Updates the calendar configuration on local store and on server
 */
export default action('saveApperanceOption')(async function saveAppearanceOption() {
    let WeekStartDay = getWeekStartDay();
    let TimeIncrement = getTimeIncrement();
    let WorkDays = getWorkDays();
    let ShowWeekNumbers = getShowWeekNumbers();
    let FirstWeekOfYear = getFirstWeekOfYear();
    let WorkingHoursStartTime = getWorkingHoursStartTime();
    let WorkingHoursEndTime = getWorkingHoursEndTime();
    let WorkingHoursTimeZoneId = getWorkingHoursTimeZoneId();

    // We can't update UserConfiguration.WorkingHours with the values from
    // MailboxConfiguration.WorkingHours - they are NOT the same. The ones
    // in UserConfiguration come shifted, based on the user's time zone,
    // while the ones in MailboxConfiguration are the raw value in the
    // working hours time zone. We save and ask the server for the new values
    // in order to ensure we are going to be consistent across session.
    updateUserOptions({
        WeekStartDay,
        HourIncrement: TimeIncrement,
        WorkingHours: { WorkDays },
        ShowWeekNumbers,
        FirstWeekOfYear,
    });

    const partialCalendarMailboxConfiguration: MailboxCalendarConfiguration = {
        WeekStartDay,
        TimeIncrement,
        WorkDays,
        ShowWeekNumbers,
        FirstWeekOfYear,
        WorkingHoursStartTime,
        WorkingHoursEndTime,
        WorkingHoursTimeZone: { TimeZoneId: WorkingHoursTimeZoneId },
    };
    updateCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);

    await saveCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);

    const userConfiguration = await getOwaUserConfigurationOperation();
    updateUserOptions({
        WorkingHours: userConfiguration.UserOptions.WorkingHours,
    });

    logDataOnSaveAppearance();

    // If the time zone checkbox was checked, the working hours time zone
    // is now the same as the user's time zone, so we can reset this value.
    // If it was not checked, the value is already null, so this would be no-op.
    setWorkingHoursTimeZoneId(null);

    // Force owa-calendar to reinitialize its own stores.
    // Ideally owa-calendar should just use the same store; eventually we'll get there.
    updateSurfaceOptions();
});
